import {apiClient} from '../apiClient';
import {
  IGetMySearchesTreeDetailsResponse,
  IMoveSavedSearchesResponse,
  ISavedSearchDataResponse,
  ISavedSearchReanamePayload,
  ISavedSearchRenameResponse,
  ISavedSearchDeletePayload,
  ISavedSearchDeleteResponse,
  ISavedSearchShareResponse,
  ISavedSearchTreeViewResponse,
  IShareSearchGroupsResponse,
} from '../types/savedsearch.types';
import {
  IRenameTreeNodeRequest,
  ResolvedNestedSearchPayload,
  ResolvedNestedSearchResponse,
} from '../types/savedSearch.type';
import BASE_URL from '../../config/env';

const savedSearchEndpoint = (path: string) =>
  `${BASE_URL}/searching/api/v1/savedsearch${path}`;

export const getSavedSearchList = async (
  payload = {}
): Promise<ISavedSearchDataResponse> => {
  const {data} = await apiClient.post(
    savedSearchEndpoint('/list/savesearchesresult'),
    payload
  );
  return data;
};

export const getShareSearchGroups =
  async (): Promise<IShareSearchGroupsResponse> => {
    const {data} = await apiClient.get(savedSearchEndpoint('/share/users'));
    return data;
  };

export const shareSearch = async (
  payload = {}
): Promise<ISavedSearchShareResponse> => {
  const {data} = await apiClient.post(savedSearchEndpoint('/share'), payload);
  return data;
};

export const renameSearch = async (
  payload: ISavedSearchReanamePayload
): Promise<ISavedSearchRenameResponse> => {
  const {data} = await apiClient.post(savedSearchEndpoint('/rename'), payload);
  return data;
};

export const deleteSearch = async (
  payload: ISavedSearchDeletePayload
): Promise<ISavedSearchDeleteResponse> => {
  const {data} = await apiClient.delete(savedSearchEndpoint('/tree/delete'), {
    data: payload,
  });
  return data;
};

export const getSavedSearchTreeView = async (): Promise<
  ISavedSearchTreeViewResponse[]
> => {
  const {data} = await apiClient.get(savedSearchEndpoint('/saved-tree'));
  return data;
};

export const getSavedSearchTreeData = async (): Promise<
  ISavedSearchTreeViewResponse[]
> => {
  const {data} = await apiClient.get(savedSearchEndpoint('/tree'));
  return data;
};

export const getMySearchesTreeDetails =
  async (): Promise<IGetMySearchesTreeDetailsResponse> => {
    const {data} = await apiClient.get('/searching/api/v1/search/tree/my');
    return data;
  };

export const moveSavedSearches = async (
  payload = {}
): Promise<IMoveSavedSearchesResponse> => {
  const {data} = await apiClient.post(
    savedSearchEndpoint('/tree/move'),
    payload
  );
  return data;
};

export const renameTreeNode = async (payload: IRenameTreeNodeRequest) => {
  const {data} = await apiClient.post(
    savedSearchEndpoint('/tree/rename'),
    payload
  );
  return data;
};

export const downloadTemplate = async (): Promise<Blob> => {
  const response = await apiClient.post(
    savedSearchEndpoint('/batch/template'),
    {},
    {
      responseType: 'arraybuffer',
    }
  );
  return new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
};

export const batchUpload = async ({formData, params}: any): Promise<any> => {
  const {data} = await apiClient.post(
    savedSearchEndpoint('/batch/upload'),
    formData,
    {params}
  );
  return data;
};

export const createTreeNode = async (payload: IRenameTreeNodeRequest) => {
  const {data} = await apiClient.post(
    savedSearchEndpoint('/tree/create'),
    payload
  );
  return data;
};

export const resolveNested = async (
  payload: ResolvedNestedSearchPayload
): Promise<ResolvedNestedSearchResponse> => {
  const {data} = await apiClient.post(
    savedSearchEndpoint('/resolve-nested'),
    payload
  );
  return data;
};
